import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { decrement, increment } from "../redux/products/actions";

const ProductsCard = () => {
  const { totalPrice, cardProducts } = useSelector((state) => state);

  // console.log(cardProducts)

  const dispatch = useDispatch();

  const productIncrementHandler = (value) => {
    dispatch(increment(value));
  };
  const productDecrementHandler = (value) => {
    dispatch(decrement(value));
  };

  const totalItems = cardProducts.reduce(
    (total, prd) => total + prd.quantity,
    0
  );

  const alertFunction = (value) => {
    alert(value);
  };

  return (
    <div className="col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-4 xxl:col-span-4">
      <div className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
        {cardProducts.length === 0 ? (
          <>
            <div className="flex justify-between border-b-2 mb-2">
              <div className="text-lg py-2">
                <p>Your Cart is Empty!</p>
              </div>
            </div>
          </>
        ) : (
          cardProducts.map((product, i) => (
            <div key={i} className="flex justify-between border-b-2 mb-2">
              <div className="text-lg py-2">
                <p>{product.name}</p>
              </div>
              <div className="text-lg py-2">
                <div className="flex flex-row space-x-2 w-full items-center rounded-lg">
                  {product.quantity <= 1 ? (
                    <button
                      onClick={() =>
                        alertFunction(
                          "No less than one product can be placed on the card."
                        )
                      }
                      className="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M18 12H6"
                        />
                      </svg>
                    </button>
                  ) : (
                    <button
                      onClick={() => productDecrementHandler(product)}
                      className="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M18 12H6"
                        />
                      </svg>
                    </button>
                  )}

                  <p>{product.quantity}</p>
                  {product.stockQuantity <= 1 ? (
                    <button
                      onClick={() =>
                        alertFunction(
                          "You cannot add more than that. Because out of stock."
                        )
                      }
                      className="bg-red-600 hover:bg-red-700 focus:outline-none text-white font-bold py-1 px-1 rounded-full inline-flex items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        />
                      </svg>
                    </button>
                  ) : (
                    <button
                      onClick={() => productIncrementHandler(product)}
                      className="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))
        )}

        <div className="flex justify-center items-center text-center">
          <div className="text-xl font-semibold">
            <p>Total Item</p>
            <p className="text-5xl">{totalItems}</p>
          </div>
        </div>
      </div>
      <div className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
        <div className="flex justify-center items-center text-center">
          <div className="text-xl font-semibold">
            <p>Total Price</p>
            <p className="text-5xl">{Math.floor(totalPrice)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsCard;
